import { DEFAULT_APP_LANGUAGAE } from "@/i18n/types/app-languages.types";
import type { OnboardingFormValues } from "../schemas/onboarding-form.schema";

export const ONBOARDING_FORM_DEFAULT_VALUES: OnboardingFormValues = {
  email: "",
  firstName: "",
  lastName: "",
  preferredLanguage: DEFAULT_APP_LANGUAGAE,
  notificationsEnabled: true,
  file: undefined,
};
